import { Head, useForm } from '@inertiajs/react'
import type { FormEvent } from 'react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

interface Props {
  flash?: { notice: string | null; alert: string | null }
}

export default function New({ flash }: Props) {
  const form = useForm({ password: '' })

  function submit(e: FormEvent) {
    e.preventDefault()
    form.post('/login', { onFinish: () => form.reset('password') })
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-5 py-12">
      <Head title="Sign in" />

      <Card className="w-full max-w-sm">
        <CardHeader className="space-y-1 text-center">
          <CardTitle className="font-display text-2xl font-semibold tracking-tight">
            Tradmusic
          </CardTitle>
          <p className="text-sm text-muted-foreground">The tunebook is locked.</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                autoFocus
                autoComplete="current-password"
                value={form.data.password}
                onChange={(e) => form.setData('password', e.target.value)}
              />
              {flash?.alert && <p className="text-xs text-destructive">{flash.alert}</p>}
            </div>

            <Button type="submit" className="w-full" disabled={form.processing}>
              Sign in
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
